import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const useCleanupRedux = cleanupAction => {
  const dispatch = useDispatch()
  useEffect(() => () => dispatch(cleanupAction()), [cleanupAction, dispatch])
}

export default useCleanupRedux
